import React from 'react';
import {connect} from 'react-redux';
import {ButtonOverlay} from '@homeaway/react-buttons';
import {getRefinements} from '../../../utils/edap';
import {reportSearchSubmit, showDatesPopup} from '../../../actions/search';

export function mapStateToProps(state) {
    const {
        destination: {propertyType},
    } = state;
    return {
        site: state.config.site,
        propertyType,
    };
}

export const AllListingsButtonComponent = ({
    dispatch,
    noFollow,
    propertyType,
    serpUrlFilters,
    segmentKey,
    className,
    label,
    lastCardUrl,
}) => {
    const onClick = (event) => {
        event.preventDefault();
        const eventrefinements = getRefinements({
            propertyType,
            refinementKey: segmentKey,
        });
        const eventcategory = '';
        const eventaction = 'link-search-click';
        const actionLocation = 'properties-module';

        reportSearchSubmit({
            actionLocation,
            eventrefinements,
            eventcategory,
            eventaction,
        });
        dispatch(
            showDatesPopup({
                actionLocation,
                eventrefinements,
                refinementKey: segmentKey,
                showDatesModal: true,
                serpUrlFilters,
                tripleId: null,
            })
        );
    };

    return lastCardUrl ? (
        <a href={lastCardUrl} onClick={onClick}>
            <ButtonOverlay label={label} className={className} />
        </a>
    ) : (
        <ButtonOverlay
            rel={noFollow === true ? 'nofollow' : null}
            label={label}
            className={className}
            onClick={onClick}
        />
    );
};

export const AllListingsButton = connect(mapStateToProps)(
    AllListingsButtonComponent
);

AllListingsButton.displayName = 'AllListingsButton';

export default AllListingsButton;
